// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3rLJW","buttons":"SendReceipts_buttons__1Iw8z","email":"SendReceipts_email__ByqRr","bookApptTitle":"SendReceipts_bookApptTitle__1KRn0"};